import _ from "lodash";
import { isAkulaku, isAkulakuAndroid, isAkulakuIOS } from "../../legacy/common/akulaku";
import config from "../../config";
import agent from "../../legacy/common/akulaku/config/agent";
// import interfaces from "./interfaces_config"
// import iOS from "../../legacy/common/akulaku/jsBridge_new/iOS/helpers/__generate__iOS__runner";
// import {registerGlobalCallback as register} from "../../legacy/common/akulaku/jsBridge_new/helpers";

const bridge = {
  isAkulaku: () => isAkulaku(),
  isAkulakuAndroid: () => isAkulakuAndroid(),
  isAkulakuIOS: () => isAkulakuIOS(),
};

const apis = Object.keys(config.apis);
for (let index in apis) {
  bridge[apis[index]] = function(jsonParams, callback) {
    return methods.bridge(apis[index], jsonParams, callback);
  };
}

// TODO 抽象为 NPM 组件，统一行为

// 参考两个文件在此手动做兼容，保持 API 总是为
// 同步 API， const result: Object = bridge.run('apiName', {p1: 1, p2: '2'})
// 异步 API， bridge.run('apiName', {p1: 1, p2: '2', callback: (result: Object) => {}})

// 常见问题，callback 的传入方法不同，返回参数可能需要自行解析为 json
// legacy/common/akulaku/jsBridge_new/android/index.js
// legacy/common/akulaku/jsBridge_new/iOS/index.js
const methods = {
  /**
   * 通用bridge 没特殊情况全部走这里 interfaces_apis配置一次就好
   * @param bridgeName
   * @param jsonObject
   * @param callback
   * @returns {*}
   */
  bridge(bridgeName, jsonObject = {}, callback) {
    agent && agent.fn(bridgeName, jsonObject, callback);
  },
};

function tryParseStringToJson(arg) {
  if (typeof arg === "string") {
    try {
      return JSON.parse(arg);
    } catch (e) {
      return arg;
    }
  } else {
    return arg;
  }
}

function tryParseObjToJson(arg) {
  if (typeof arg === "string") {
    return tryParseStringToJson(arg);
  } else if (Array.isArray(arg)) {
    return arg.map(x => tryParseObjToJson(x));
  } else if (_.isPlainObject(arg)) {
    return Object.keys(arg).reduce((accumulator, curKey) => {
      accumulator[curKey] = tryParseObjToJson(arg[curKey]);
      return accumulator;
    }, {});
  } else {
    return arg;
  }
}

// 添加webview事件回调
window.__webview__event__emit = (res)=>{
  res = typeof res === "string" ? JSON.parse(res) : res
  const eventName = _.get(res, "data.eventName")
  const detail = _.get(res, "data.extraData")
  if (!eventName) {
    console.warn("webview event eventName is required")
    return;
  }
  const event = new CustomEvent(eventName, {detail: detail, bubbles: true});
  document.dispatchEvent(event)
}

export default bridge;
